import React, { useState,useEffect, useContext } from 'react'
import CustomWrapper from '../../wrapper/CustomWrapper'
import "./PaymentDashboard.css"
import Button from '../../Button/Button'
import HighlighterButton from '../../Button/HighlighterButton'
import SmallNote from '../../note/SmallNote'
import CustomTable from '../../table/CustomTable'
import { SampleTableData } from '../../table/SampleTableData'
import Calendar from '../../Calendar/Calendar'
import PopupWrapper from "../../wrapper/PopupWrapper"
import { getDaysDifference, isLoggedIn } from '../../../utility/util'
import { getRenterDues, loadRenterDetails } from '../../../services/property.service'
import { createNewTransactionForUser, getAllTrancationsForUser, verifyBankAccount } from '../../../services/payment.method.service'
import { FormException } from '../../../utility/exceptions'
import { AppContext } from '../../../App'
import HatTrophy from "../../../assets/hat.png"
import { useNavigate } from 'react-router-dom'
import Checkbox from '../../checkbox/Checkbox'
import { Loader, MiniLoader } from '../../Loader/Loader'
import dayjs from 'dayjs'

function PaymentDashboard({userData = null, paymentAccounts=null}) {
  const [isOneTimePayment, setIsOneTimePayment] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [stepTitle, setStepTitle] = useState("Make a one-time payment.");
  const [paymentAccountList, setPaymentAccountList] = useState(null);
  const [dueDate, setDueDate] = useState(new Date());
  const [pendingAmount, setPendingAmount] = useState(0);
  const [customTableData, setCustomTableData] = useState([]);
  const [penalty, setPenalty] = useState(0);
  const navigate = useNavigate();
  const [calendarD, setCalanderD] = useState(new Date())
  const appContext = useContext(AppContext);
  const [rentPaid, setRentPaid] = useState(false)
  const [rentPaidAmount, setRentPaidAmount] = useState(0)
  const [rentMonthList, setRentMonthList] = useState([]);
  const [payType, setPayType] = useState("full");
  const [paidMonths, setPaidMonths] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  useEffect(() => {
    document.title = "Payment Details | Renter | Ando";    
    let uInfo = isLoggedIn();
    if (userData == null) {
      userData = uInfo;
    }
    loadDues();
  }, []);

  useEffect(() =>{
    let accountList =[];
    paymentAccounts?.forEach((acc) => {
      
      accountList.push(
        <PaymentBox payment_token_id={acc.id} paymentType={acc.payment_type} paymentDetails={acc.detail} primary={acc?.isPrimary} status={acc?.status}/>
      )
    })
    setPaymentAccountList([...accountList]);
  }, [paymentAccounts])

  const loadDues = () => {
    setLoading(true)
    getRenterDues(userData?.data?.id)
    .then((duesResp) =>{
      setLoading(false)
      if(duesResp?.length > 0){
        setDueDate(
          new Date(`${duesResp?.at(0)?.year}-${String(duesResp?.at(0)?.month)?.padStart(2, "0")}-01 00:00:00`)
        )
        setPenalty(duesResp?.at(0)?.penalty ?? 0);
        let pendingAmountSum = 0;
        duesResp?.forEach((item) => {
          const date1 = new Date(`${item.year}-${String(item.month).padStart(2, "0")}-01`);
          const date2 = new Date();
          const differenceInDays = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
          pendingAmountSum += item?.rent + (differenceInDays <= 16 ? 0 :  (item?.penalty ?? 0))
        })
        setPendingAmount(pendingAmountSum)
        setRentMonthList(duesResp?.map((e) => {
          const date1 = new Date(`${e.year}-${String(e.month).padStart(2, "0")}-01`);
          const date2 = new Date();
          const differenceInDays = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
          return {
            ...e, 
            penalty : differenceInDays <= 16 ? 0 : e.penalty,
            isChecked : false
          }
        }))
      }
      else{
        setPendingAmount(0)
      }
    })
    .then(() => {      
      fetchTransactions();
    })
    .catch((error) =>{
      setLoading(false)
    })
  }
  const fetchTransactions = () => {
    setLoading(true)
    getAllTrancationsForUser(userData?.data?.id)
    .then((resp) => {
      setLoading(false)
      let amountPaidTillDate = 0;
      if(resp.status){
        let customData = [];
        resp.data?.forEach((element) => { 
          amountPaidTillDate += parseFloat(element.rentAmount);
          let paymentDate = new Date(element.created_at);
          let rentFor = new Date(`16 ${element?.transactionDetails?.rentPeriod}`)
          let paymentStatus = paymentDate > rentFor ? "Late" : "On Time";
          let rentAmt = element.rentAmount != null ? parseFloat(element.rentAmount) : null;
          let totalAmt = element.totalAmount != null ? parseFloat(element.totalAmount) : null;
          let data = {
            "Payment Date" : `${paymentDate.getDate()} ${paymentDate.toLocaleString("default", { month: "long" })}, ${paymentDate.getFullYear()}`,
            "Rent Amount" : "$" + (rentAmt != null ? rentAmt.toFixed(2) : '0.00'),
            "Amount Paid" : "$" + (totalAmt != null ? totalAmt.toFixed(2) : (rentAmt != null ? rentAmt.toFixed(2) : '0.00')),
            "Rent Period" : `${element?.transactionDetails?.rentPeriod}`,
            "Status" : paymentStatus,
            "Balance" : "$" + (element.transactionDetails.balance == null ? 0 : element.transactionDetails.balance),
          }
          customData.push(data)
        })
        setCustomTableData([...customData]);
      }   
    })
  }

  const performOneTimePayment = ()=>{
    if(pendingAmount > 0)
      setIsOneTimePayment(true);
    else{
      appContext.toastRef.current.launch("Rent already paid");
    }
  }

  const onClose = ()=>{
    setIsOneTimePayment(false);
  }

  const payRent = (e) => {
    e.preventDefault();
    setLoading(true)
    let messageDiv = document.getElementsByClassName("message").item(0);

    let paymentAmountType = e.target.paymentAmountSelect.value;
    let rentTobePaid = rentMonthList;
    if(paymentAmountType.trim().length == 0){
      setLoading(false)
      return FormException(e, "Select valid rent amount", messageDiv);
    }

    if(paymentAmountType == 'other'){
      let pendingAmountSum = rentMonthList?.filter((item) => item?.isChecked);
      
      if(pendingAmountSum?.length == 0){
        setLoading(false)
        return FormException(e, "Select Any from Rent Timeline", messageDiv);
      }
      else{
        rentTobePaid = pendingAmountSum
      }
    }

    let paymentType = e.target.paymentType.value;

    if(paymentType == null || paymentType == undefined || paymentType.trim().length == 0){
      setLoading(false)
      return FormException(e, "Select valid payment method", messageDiv);
    }
    rentTobePaid = rentTobePaid?.sort((item1, item2) =>{
      if(item1?.year !== item2?.year)
        return item1?.year - item2?.year;
      return item1?.month-item2?.month
    })
    
    createNewTransactionForUser({
      amount : rentTobePaid,
      selectedPaymentAmount : selectedPaymentAmount,
      displayFinalAmount : displayFinalAmount,
      payment_token_id : paymentType,
      user_id : userData?.data?.id,
    })
    .then((resp) => {
      setLoading(false)
      let totalAmount = 0;
      rentTobePaid?.forEach((item) =>{
        totalAmount += item?.rent + (item?.penalty ?? 0)
      })
      setRentPaidAmount(isNaN(totalAmount) ? 0 : totalAmount);
      onClose()
      if(!resp?.status){
        appContext.toastRef.current.launch(resp?.message || "Could not process payment | Contact Support")
      }
      else{
        let t = rentTobePaid?.filter((e) => payType == 'full' ? true : e?.isChecked)?.map((e) => {
          let temp = new Date(`${e?.year}-${String(e?.month)?.padStart(2, "0")}-01 00:00:00`)
          let dateDiff = getDaysDifference(temp, new Date())
          if(dateDiff <= 15){
            setPaymentStatus("On Time")
          }
          if(dateDiff >= 16){
            setPaymentStatus("Late")
          }
          return `${temp.toLocaleString("default", {month : "long"})} ${temp.getFullYear()}`
        })
        setPaidMonths(t.join(", "))
        setRentPaid(true)
        loadDues();
        fetchTransactions()
      }
    })
    messageDiv.style.display = "none"
  }
  const setupAutopay = () => {
    appContext.toastRef.current.launch("Feature is in maintainence");
  }

  const selectedPaymentAmount = (() => {
    if (payType === "full") {
      return pendingAmount;
    }
    const selectedMonths = rentMonthList?.filter((item) => item?.isChecked) || [];
    return selectedMonths?.reduce((sum, item) => sum + item?.rent + (item?.penalty ?? 0), 0);
  })();

  // Calculate final payment amount with 4% fee for credit cards
  const calculateFinalPaymentAmount = () => {
    // First check for manually selected payment method
    let selectedPaymentMethod = document.querySelector('input[name="paymentType"]:checked')?.value;
    
    // If no method selected via radio button, use the primary/default payment account
    if (!selectedPaymentMethod) {
      const primaryAccount = paymentAccounts?.find(acc => acc.isPrimary);
      selectedPaymentMethod = primaryAccount?.id;
    }
    
    if (!selectedPaymentMethod) {
      return selectedPaymentAmount;
    }

    // Find the selected payment account details
    const selectedPaymentAccount = paymentAccounts?.find(acc => acc.id == selectedPaymentMethod);
    const selectedPaymentDetails = selectedPaymentAccount?.detail;
    const cardFunding = selectedPaymentDetails?.funding || selectedPaymentDetails?.cardType;
    const isCreditCard = cardFunding?.toLowerCase() === 'credit';

    // Apply 4% processing fee for credit cards and format to 2 decimal places
    const paymentFinalAmount = isCreditCard ? (selectedPaymentAmount * 1.04).toFixed(2) : selectedPaymentAmount.toFixed(2);

    return paymentFinalAmount;
  };

  const displayFinalAmount = calculateFinalPaymentAmount();

  const daysCalculator = () => {
    let temp = Math.floor((new Date(
      dueDate.getFullYear(),
      dueDate.getMonth(),
      dueDate.getDate() + 15
      ) - new Date()) / 1000 / 60 / 60 / 24)
    return temp > 0 ? temp : 0
  }
  return (
    <>
    
      <CustomWrapper
        width='auto'
        maxWidth={"auto"}
        height='100%'
        marginHorizontal='50px'
        marginVertical='10px'
        paddingHorizontal={30}
        paddingVertical={30}
      >
        <div className='paymentDashboard'>
          <div className='infoContainer'>
            <div className='balanceInfo'>
              <div className='leftDiv'>
                <span>Current Balance : </span>
                {
                  pendingAmount > 0 && 
                  <p>Due {dueDate.toLocaleString("en-gb", { month: "long"})} {dueDate.toLocaleString('en-gb', {day : 'numeric'})}, {dueDate.toLocaleString('en-gb', {year : 'numeric'})}</p>
                }
              </div>
              <div className='rightDiv'>
                {
                  isLoading && <MiniLoader />
                }
                {
                  !isLoading && 
                  <span>${pendingAmount}</span>
                }
              </div>
            </div>
            <div className='infoButtonContainer'>
              <Button className='minButton infoButton'
              onPressFunction={performOneTimePayment}>
                Make a One Time Payment
              </Button>
              <HighlighterButton onPressFunction={setupAutopay} className='minButton infoButton' fontSize='15px'>
                Set up auto pay
              </HighlighterButton>
            </div>
          </div>
          {
            pendingAmount > 0 && (dueDate - new Date()) < 0 &&
            <SmallNote><b>Friendly Reminder : </b> You have {daysCalculator()} days left in your grace period. To avoid late fee of ${isNaN(penalty) ? 0 : penalty} please make your payment on or before {new Date(
                dueDate.getFullYear(),
                dueDate.getMonth(),
                dueDate.getDate() + 15
                ).toDateString()}.</SmallNote>
          }
          <CustomTable
            title={"Payment Transactions"}
            json={customTableData}
          />
        </div>
        {isOneTimePayment && (
          <form onSubmit={payRent}>
          <PopupWrapper maxWidth={"auto"} height="90%" overflowY="auto" onClose={onClose}>
            <div className="OnTimePaymentTitle"> {stepTitle}</div>
            <h5 className="header5">Select payment date.</h5>
          <Calendar 
            currentDate={calendarD}
            setCurrentDate={setCalanderD}
            dueDate={dueDate}
            amount={penalty}
            expDate={
              new Date(
                dueDate.getFullYear(),
                dueDate.getMonth(),
                dueDate.getDate() + 15
                )
              }
              isEditable={false}
            />
            <br />
            <hr className="hrLine" />
            <h5 className="header5">Select payment amount.</h5>
            <div style={{display :'flex', flexDirection : 'column', gap : 15}}>
              <div className="rowPaymentAmount" style={{flexDirection : 'row'}}>
                <div>
                  <label className="paymentRadio">
                    <input 
                      type="radio" 
                      checked={payType === "full"} 
                      name="paymentAmountSelect" 
                      value="fixed" 
                      onChange={() => {
                        setPayType("full")
                        setRentMonthList(rentMonthList?.map((item) => {
                          return {
                            ...item,
                            isChecked : false
                          }
                        }))
                      }}
                    />
                    <p>Pay Balance</p>
                  </label>
                </div>
                <div>
                  <input type="hidden" name={"fixedAmount"} value={pendingAmount}/>
                  <div className="Amount" style={{textAlign : "start"}}>${pendingAmount}</div>
                </div>
              </div>
              {
                !(rentMonthList?.length == 1 && rentMonthList?.at(0)?.month === new Date().getMonth() + 1 && rentMonthList?.at(0)?.year === new Date().getFullYear() )&&
                <div className="rowPaymentAmount">
                  <div>
                    <label className="paymentRadio">
                      <input type="radio" name="paymentAmountSelect" value="other" checked={payType === "other"} onChange={() => setPayType("other")} />
                      <p>Pay Other Amount</p>
                    </label>
                  </div>
                  <div style={{
                      marginTop : -10, 
                      marginLeft : 10, 
                      display : 'flex', 
                      flexDirection : 'row', 
                      gap : 10, 
                      width : '100%', 
                      overflowX : 'auto', 
                      background : (payType !== "other") ? "rgba(0,0,0,0.05)" : "#FFFFFF"
                    }} 
                    className='scroller'>
                    {
                      rentMonthList?.map((item, index) => {
                        let date = new Date(`${item?.year}-${String(item?.month)?.padStart(2, "0")}-01 00:00:00`)
                        return (
                            <Checkbox
                              key={index}
                              name={"rentPayMonths"+index}
                              label={`${date?.toLocaleString("default", {month : "short"})} ${date?.getFullYear()} - $${item?.rent + (item?.penalty ?? 0)}`}
                              isChecked={item?.isChecked}
                              onChange={() => {
                                if(payType === "other"){
                                  setRentMonthList([...rentMonthList?.map((e, i) => {
                                    if(i === index){
                                      return {
                                        ...e,
                                        isChecked : !e?.isChecked
                                      }
                                    }
                                    return e;
                                  })])
                                }
                              }}
                              labelStyle={{textWrap : 'nowrap', fontSize : 12, color : "rgba(0,0,0,0.7)"}}
                            />
                        )
                      })
                    }
                  </div>
                </div>
              }
            </div>
            <br />
            <hr className="hrLine" />
            <h5 className="header5">Select payment method.</h5>
            <div className="PaymentMethod-Container">
              {paymentAccountList}
              <div className="paymentMethod">
                <div>
                  <label className="paymentRadio" onClick={() => {navigate("/renter/payment/account/manage")}}>
                    <input type="radio" name="paymentType" value={null}/>
                    <span>Pay with a different method</span>
                  </label>
                </div>
              </div>
            </div>
            <hr className="hrLine" />
            <div className="finalPaymentDiv">
              <div className="label_payment">Final payment amount:</div>
              <div className="finalPaymentAmount">${isNaN(displayFinalAmount) ? '0.00' : displayFinalAmount}</div>
            </div>
            <div className='message' style={{marginTop : 30, marginBottom : -50}}>Sample Text</div>
            <div className="PayRent">
              <Button
                primary={true}
                margin="0"
                paddingVertical="8px"
                type="submit"
                className="btnPayRent"
              >
                Pay Rent
              </Button>
            </div>
          </PopupWrapper>
        </form>
        )
        }
      </CustomWrapper>
      {
        rentPaid &&
        <PopupWrapper onClose={() => {setRentPaid(false)}} maxWidth={550}>
          <div style={{display : "flex", flexDirection : "row", gap : 5, alignItems : "center"}}>
            <img src={HatTrophy} alt='' height={100}/>
            <div style={{maxWidth : 400}}>Rad! You’ve paid ${isNaN(rentPaidAmount) ? 0 : rentPaidAmount} in rent {paymentStatus} for {paidMonths}. 
              We posted it to your account on {(new Date())?.toLocaleString("default", {month : "long"})} {(new Date()).getDate()}, {calendarD.getFullYear()}. </div>
          </div>
        </PopupWrapper>
      }
      {
        isLoading && <Loader />
      }
    </>
  )
}

const PaymentBox = ({payment_token_id, paymentType, paymentDetails, primary = false, status = 'Active'}) => {
  const [verifying, setVerifying] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [verifyError, setVerifyError] = useState('');
  const [verified, setVerified] = useState(status === 'Active');
  const isPending = status === 'pending_verification' && !verified;

  const handleVerify = async (e) => {
    e.preventDefault();
    setVerifyError('');
    const amount1 = parseInt(e.target.amount1.value);
    const amount2 = parseInt(e.target.amount2.value);
    if (isNaN(amount1) || isNaN(amount2) || amount1 <= 0 || amount2 <= 0) {
      setVerifyError('Please enter valid amounts in cents (e.g., 32 and 45)');
      return;
    }
    setVerifying(true);
    try {
      const resp = await verifyBankAccount(payment_token_id, [amount1, amount2]);
      if (resp?.status) {
        setVerified(true);
        setShowVerifyPopup(false);
      } else {
        setVerifyError(resp?.message || 'Verification failed. Please check the amounts.');
      }
    } catch (err) {
      setVerifyError(err?.message || 'Verification failed. Please try again.');
    }
    setVerifying(false);
  };

  const rawBrand = paymentDetails?.brand || paymentDetails?.cardBrand || paymentDetails?.network;
  const cardBrand = rawBrand ? `${rawBrand}`.toUpperCase() : "CARD";
  const cardFunding = paymentDetails?.funding || paymentDetails?.cardType;
  const formattedCardType = cardFunding
    ? `${cardFunding.charAt(0).toUpperCase()}${cardFunding.slice(1)} Card`
    : "Card";
  const last4 = paymentDetails?.last4 || paymentDetails?.cardNumber?.substring(paymentDetails.cardNumber.length - 4) || "0000";
  const expMonth = paymentDetails?.expMonth || paymentDetails?.expiryMonth || "--";
  const expYear = paymentDetails?.expYear || paymentDetails?.expiryYear || "----";
  return (
    <>
      {
        paymentType == 'card' &&
        <>
          <div className="paymentMethod">
            <label className="paymentRadio">
              <input type="radio" name="paymentType" value={payment_token_id} checked={primary}/>
              <div className='paymentMethodLeft'>
                <div className='paymentMethodBrand'>{cardBrand}</div>
                <div className='paymentMethodLast4'>****{last4}</div>
              </div>
              <div className='paymentMethodMeta'>
                <div className='paymentMethodType'>{formattedCardType}</div>
                <div className='paymentMethodExp'>Exp {expMonth}/{expYear}</div>
              </div>
            </label>
          </div>
          <div className="paymentMethodFeeNote">Credit card transactions will incur a 4% fee.</div>
        </>
      }
      {
        paymentType == "account" &&
        <div className="paymentMethod" style={isPending ? {opacity: 0.6} : {}}>
          <div>
            <label className="paymentRadio">
              <div className='paymentMethodLeft'>
                <input type="radio" name="paymentType" value={payment_token_id} checked={primary} disabled={isPending}/>
                <div className='paymentModeName'>
                  {paymentDetails.accountNickname}
                  <p>{paymentType}</p>
                </div>
                <span>*****{paymentDetails.accountNumber.substring(paymentDetails.accountNumber.length - 4)}</span>
              </div>
            </label>
          </div>
          <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <div className="expDate"> Routing No. {paymentDetails.routingNumber.substring(paymentDetails.routingNumber.length - 4)}</div>
            {isPending && (
              <button
                type="button"
                onClick={() => setShowVerifyPopup(true)}
                style={{padding: '4px 12px', fontSize: 12, cursor: 'pointer', background: '#e8a300', color: '#fff', border: 'none', borderRadius: 4, whiteSpace: 'nowrap'}}
              >
                Verify Account
              </button>
            )}
            {verified && status === 'pending_verification' && (
              <span style={{fontSize: 12, color: '#2e7d32', fontWeight: 600}}>Verified</span>
            )}
          </div>
          {showVerifyPopup && (
            <PopupWrapper maxWidth={400} onClose={() => setShowVerifyPopup(false)}>
              <div style={{padding: 10}}>
                <h4 style={{margin: '0 0 8px'}}>Verify Bank Account</h4>
                <p style={{fontSize: 13, color: '#555', margin: '0 0 12px'}}>Two small deposits were sent to your bank account. Enter the amounts in cents to verify.</p>
                <form onSubmit={handleVerify}>
                  <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                    <input name="amount1" type="number" placeholder="Amount 1 (cents)" min="1" required style={{flex: 1, padding: 8, border: '1px solid #ccc', borderRadius: 4}}/>
                    <input name="amount2" type="number" placeholder="Amount 2 (cents)" min="1" required style={{flex: 1, padding: 8, border: '1px solid #ccc', borderRadius: 4}}/>
                  </div>
                  {verifyError && <div style={{color: 'red', fontSize: 12, marginBottom: 8}}>{verifyError}</div>}
                  <div style={{display: 'flex', gap: 10, justifyContent: 'flex-end'}}>
                    <button type="button" onClick={() => setShowVerifyPopup(false)} style={{padding: '6px 16px', cursor: 'pointer', background: '#eee', border: 'none', borderRadius: 4}}>Cancel</button>
                    <button type="submit" disabled={verifying} style={{padding: '6px 16px', cursor: 'pointer', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4}}>{verifying ? 'Verifying...' : 'Verify'}</button>
                  </div>
                </form>
              </div>
            </PopupWrapper>
          )}
        </div>
      }
    </>
  )
}

export default PaymentDashboard